/*
 * @Author: wangkg wangkegui@longfor.com
 * @Date: 2022-12-23 07:52:23
 * @LastEditors: wangkg wangkegui@longfor.com
 * @LastEditTime: 2022-12-23 07:52:54
 * @FilePath: /unified-development-platform/src/apis/auth/user.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { request,loginRequest } from '@/apis/request'
const VERSION = '/v1.0.0'
const PRE_PATH = '/cBondIssuance/center';
export function loginConf(data) {
  return request({
    url: '/shop/app/add',
    method: 'post',
    data: {
      'header': {
        'service': 'memberServiceImpl',
        'requestType': 'SMARTFORM',
        'requestParam': {
          'formCode': '',
          'entityId': 'c439748a-19b0-11eb-9e6c-000c294a78d1',
          'menuCode': ''
        },
        'requestTime': '2020-09-09 12:12:12'
      },
      'body': {
        'entity': {
          'id': '',
          'prop': {
            'code': 'member',
            'name': '会员表单',
            'entityId': 'member',
            'status': 'D',
            'age': '11'
          }
        }
      }
    }
  })
}
export function login(data) {
  return loginRequest({
    url: 'http://10.10.52.245:4000/org.gocom.components.coframe.auth.LoginManager.login.biz.ext',
    method: 'post',
    data
  })
}
export function getInfo(hideLoading = false) {
  return request({
    url: '/v1/sys/sysUser/userInfo',
    method: 'post',
    hideLoading
  })
}

export function getUserInfo(data) {
  return request({
    url: `${PRE_PATH}/UserLogin${VERSION}`,
    method: 'post',
    data,
    hideLoading:false
  });
}

